(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];

  function toast(message){
    const el = qs('#Toast');
    if(!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(window.__ppToast);
    window.__ppToast = setTimeout(() => el.classList.remove('is-visible'), 2200);
  }

  async function refreshCartDrawer(){
    const drawer = qs('#CartDrawerContent');
    if(!drawer) return;
    try{
      const res = await fetch('/cart.js', {headers:{Accept:'application/json'}});
      const cart = await res.json();
      if(!cart.items.length){
        drawer.innerHTML = '<div class="cart-empty"><h3>Your cart is empty</h3><p class="muted">Add an RC and come back here when you’re ready.</p><a class="btn btn--primary" href="/collections/all">Shop RC Cars</a></div>';
        return;
      }
      const items = cart.items.map(item => `
        <div class="drawer-item">
          <img src="${item.image ? item.image : ''}" alt="${escapeHtml(item.product_title)}">
          <div class="drawer-item__meta">
            <strong>${escapeHtml(item.product_title)}</strong>
            <span>${item.quantity} × ${formatMoney(item.final_price)}</span>
          </div>
          <button class="icon-button" type="button" data-remove-line="${item.key}" aria-label="Remove ${escapeHtml(item.product_title)}">×</button>
        </div>`).join('');
      drawer.innerHTML = `
        <div>${items}</div>
        <div class="drawer-footer">
          <div class="cart-summary__line"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div>
          <p class="small muted">Shipping and taxes are calculated at checkout.</p>
          <a class="btn btn--primary btn--full" href="/cart">Checkout</a>
          <a class="btn btn--secondary btn--full" href="/cart" style="margin-top:8px">View cart</a>
        </div>`;
      qsa('[data-remove-line]', drawer).forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch('/cart/change.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({id:btn.dataset.removeLine, quantity:0})
          });
          refreshCartDrawer();
          refreshCartCount();
        });
      });
    }catch(e){ drawer.innerHTML='<p class="muted">Unable to load your cart right now.</p>'; }
  }

  function formatMoney(cents){
    return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format(cents/100);
  }
  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  }
  async function refreshCartCount(){
    try{
      const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
      const c=await r.json();
      qsa('[data-cart-count]').forEach(el=>el.textContent=c.item_count);
    }catch(e){}
  }

  function openCart(){
    const drawer=qs('#CartDrawer');
    if(!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    document.body.classList.add('no-scroll');
    refreshCartDrawer();
  }
  function closeCart(){
    const drawer=qs('#CartDrawer');
    if(!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    document.body.classList.remove('no-scroll');
  }

  qsa('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));
  qsa('[data-cart-close]').forEach(b=>b.addEventListener('click',closeCart));

  const menuToggle=qs('[data-mobile-menu]');
  const mobileNav=qs('#MobileNav');
  if(menuToggle && mobileNav){
    menuToggle.addEventListener('click',()=>{
      const open=mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded',open?'true':'false');
    });
  }

  qsa('form[data-add-to-cart]').forEach(form=>{
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const btn=qs('button[type="submit"]',form);
      if(btn) btn.disabled=true;
      try{
        const data=new FormData(form);
        const r=await fetch('/cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
        if(!r.ok) throw new Error('Add failed');
        refreshCartCount();
        toast('Added to cart');
        openCart();
      }catch(err){ toast('Could not add this item. Please try again.'); }
      finally{ if(btn) btn.disabled=false; }
    });
  });

  qsa('[data-qty-minus],[data-qty-plus]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const wrap=btn.closest('[data-quantity]');
      const input=qs('input',wrap);
      const min=parseInt(input.min||1,10);
      let value=parseInt(input.value||1,10);
      value += btn.hasAttribute('data-qty-plus') ? 1 : -1;
      input.value=Math.max(min,value);
    });
  });

  qsa('[data-gallery-thumb]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const img=qs('[data-gallery-main]');
      if(!img) return;
      img.src=btn.dataset.galleryThumb;
      qsa('[data-gallery-thumb]').forEach(x=>x.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  qsa('[data-finder-option]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const group=btn.dataset.finderGroup;
      qsa(`[data-finder-option][data-finder-group="${group}"]`).forEach(x=>x.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  refreshCartCount();
})();